import { BaseSyntheticEvent, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { emailValidateion } from "../../../common/Valitation";
import { OnsiteTextField } from "../../../customelements/CustomInput";
import { MessageParam } from "../../Message";
import { HttpPostData, JumpPage } from "../../../common/Util";
import { ResponseParamBase } from "../../../common/Types";
import { LoginStateConext } from "../../../context/AuthContext";
import { TitleParamContext } from "../../../context/TitleContext";
import market from "../../../css/market.module.scss";
import base from "../../../css/base.module.css";

//パスワード変更画面
export interface IFormInputs {
    email: string
}

type ResponseParam = ResponseParamBase & {
}

const schema = Yup.object({
    email: emailValidateion
}).required();

export const ChangeMailAddress = () => {

    const ctx = useContext(TitleParamContext);
    const loginState = useContext(LoginStateConext);

    const { register, handleSubmit, control, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            email: loginState.loginInfo.email,
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const userProvider = useContext(LoginStateConext);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        setMessage("");
        await HttpPostData<ResponseParam>("/UserManager/CreateChangeEmailToken", { username: userProvider.loginInfo.userName, currentemail: userProvider.loginInfo.email, newemail: data.email }, setIsLoading)
            .then(response => {
                if (response.status == 200 && response.data.resultFlg) {
                    const responsedata = response.data;
                    JumpPage<MessageParam>("Message", { message: responsedata.message, displayButton: true }, "", navigate);
                } else {
                    setMessage(response.data.message);
                }
            })
            .catch(e => {
                setMessage("処理中にエラーが発生しました。");
            })
    }

    useEffect(() => {
        ctx.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "メールアドレス変更", secondSubTitle: "" });
    }, []);

    return (
        <>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputTitle}>
                                <h3>メールアドレス</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="email"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            {...register}
                                            error={errors.email ? true : false}
                                            helperText={errors.email?.message}
                                            margin="normal"
                                            type="email"
                                        />
                                    )}
                                />
                                <p>
                                    本登録確認メールをお送りします。<br />
                                    受信可能なメールアドレスを入力下さい。
                                </p>
                            </div>                            
                        </div>
                        <div className={base.errorMessage}>{message}</div>
                        <div className={market.marketFooterArea}>
                            <button className={market.marketBackButton} type="button" onClick={(e) => { JumpPage("/MyPage", {}, "", navigate); }}>戻る</button>
                            <button className={market.marketButton} type="submit" disabled={!isValid || isLoading}>仮登録</button>
                            <button style={{ visibility: "hidden" }} className={market.marketBackButton}>＜　進む</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
}